import { networkService } from "services/networkService";
import {
     METHOD_DATABASE_LIST,
     METHOD_DATABASE_CREATE,
     METHOD_DATABASE_UPDATE,
     METHOD_DATABASE_DELETE,
     METHOD_DATABASE_DETAIL
 
} from "constants/admin/masters/database";
class DatabaseService {
  getAllDatabaseType = (data) => {
    return networkService
      .post(METHOD_DATABASE_LIST, data)
      .then((response) => response.data);
  };
 getDatabaseDetail = (id) => {
    const updatedMethodName = METHOD_DATABASE_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createDatabase = (data) => {
    return networkService
      .post(METHOD_DATABASE_CREATE, data)
      .then((response) => response.data);
  };
  updateDatabase = (data, id) => {
    const updatedMethodName = METHOD_DATABASE_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteDatabase = (id,is_delete=false) => {
    const updatedMethodName = METHOD_DATABASE_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };
}
export default DatabaseService;